import { DeliveriesStore, DeliveryIndentifier } from "../Deliveries/DeliveriesStore";
import { UrlProvider } from "../../Infrastructure/UrlProvider";

interface EventMap {
    "comments-updating": void;
    "comment-added": Comment;
}


export class CommentsStore {
    private _eventTarget = new EventTarget();
    private static _instance = new CommentsStore();
    public static get instance() { return CommentsStore._instance; };

    addEventListener<K extends Extract<keyof EventMap, string>>(type: K, listener: (this: EventSource, ev: CustomEvent<EventMap[K]>) => any, options?: boolean | AddEventListenerOptions) {
        return this._eventTarget.addEventListener(type, listener, options);
    }

    removeEventListener<K extends Extract<keyof EventMap, string>>(type: K, listener: (this: EventSource, ev: CustomEvent<EventMap[K]>) => any, options?: boolean | AddEventListenerOptions) {
        return this._eventTarget.removeEventListener(type, listener, options);
    }

    private emit<K extends Extract<keyof EventMap, string>, T extends EventMap>(type: K, value?: T[K]) {
        return this._eventTarget.dispatchEvent(new CustomEvent(type, { detail: value }));
    }

    public async addComment(deliveryIdentifier: DeliveryIndentifier, comment: string, routeName?: string) { 
        const body = {
            text: comment,
            deliveryType: deliveryIdentifier.type,
        };

        const documentNumber = DeliveriesStore.resolveDocumentNumber(deliveryIdentifier);
        
        const response = await fetch(`${UrlProvider.root}/api/comments/${documentNumber}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(body),
        });

        if (response.ok) {
            this.emit("comment-added", { invoiceId: deliveryIdentifier.invoiceNo, text: comment, routeName: routeName });
        }
    }
}

export class Comment { 
    text: string;
    invoiceId?: string;
    routeName?: string;
}